<template>
  <div class="w-full">
    <div class="flex flex-col md:flex-row items-stretch md:items-end justify-between mb-3 gap-3">
      <button
          type="button"
          @click="markPerfect"
          class="w-full md:w-auto md:ml-4 bg-purple-50 text-secondary px-4 py-2 rounded-lg text-sm font-medium hover:bg-purple-100 transition flex items-center justify-center gap-2 order-1 md:order-2"
      >
        <Icon name="wand_stars" class="w-5 h-5 text-xl text-zinc-800" />
        <span class="text-base text-zinc-800">{{ __('Mark as Perfect')}}</span>
      </button>

      <h4 class="order-2 md:order-1 text-sm font-medium text-zinc-800 text-left">{{ __('Associate Number of Points')}}</h4>
    </div>

    <VueSlider
        :rail-style="railStyle"
        :process-style="processStyle"
        :tooltip-style="tooltipStyle"
        :height="8"
        :dot-size="24"
        :tooltip-formatter="tooltipFormatter"
        :min="min"
        :max="max"
        :interval="interval"
        :model-value="internalValue"
        @update:model-value="handleUpdateModelValue"
    >
      <template #dot>
        <div class="h-full w-full rounded-full bg-white">
          <div class="h-full w-full rounded-full bg-secondary/10 p-0.5">
            <div class="h-full w-full rounded-full bg-secondary p-1">
              <div class="h-full w-full rounded-full bg-white"></div>
            </div>
          </div>
        </div>
      </template>
    </VueSlider>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import VueSlider from "vue-3-slider-component";
import {Icon} from "@/components/global";
import {__} from "@/helpers";

const props = defineProps({
  modelValue: { type: Number, default: 0 },
  min: { type: Number, default: 0 },
  max: { type: Number, default: 200 },
  interval: { type: Number, default: 1 },
});

const emit = defineEmits(['update:modelValue', 'mark-perfect']);

const internalValue = ref(Number(props.modelValue ?? 0));
watch(() => props.modelValue, (v) => { internalValue.value = Number(v ?? 0); });

const railStyle = computed(() => ({
  backgroundColor: `rgba(var(--tw-secondary-color, 139,92,246), 0.08)`
}));
const processStyle = computed(() => ({
  backgroundColor: `rgba(var(--tw-secondary-color, 139,92,246), 1)`
}));
const tooltipStyle = computed(() => ({
  backgroundColor: `rgba(var(--tw-secondary-color, 139,92,246), 1)`,
  borderColor: `rgba(var(--tw-secondary-color, 139,92,246), 1)`
}));

function tooltipFormatter(v) {
  return String(v);
}

function handleUpdateModelValue(v) {
  internalValue.value = Number(v ?? 0);
  emit('update:modelValue', internalValue.value);
}

function markPerfect() {
  const perfect = Number(props.max);
  internalValue.value = perfect;
  emit('update:modelValue', perfect);
  emit('mark-perfect', perfect);
}
</script>

<style scoped>
::v-deep .vue-slider-dot-tooltip,
::v-deep .vue-slider-tooltip {
  top: calc(100% + 8px) !important;
  bottom: auto !important;
  transform: translateX(-50%) !important;
}

::v-deep .vue-slider-dot-tooltip-inner-top:after {
  top: -39% !important;
  left: 50% !important;
  transform: translate(-50%) rotate(180deg) !important;
}
</style>